import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { AUTH_UPDATE_PROFILE_SELECTED_PLANS } from 'redux/actions/_actionTypes'
import { getUserData } from 'services/me'

interface Return {
  updateProfileSelectedPlansLocally: () => void
}

export const useUpdateProfileSelectedPlansLocally = (): Return => {
  const dispatch = useDispatch()

  const { refetch } = useQuery({
    queryKey: ['GET_USER_DATA'],
    queryFn: getUserData,
    enabled: false,
    onSuccess: (data) => {
      const plans = data.person_profile[0]?.plans
      dispatch({ type: AUTH_UPDATE_PROFILE_SELECTED_PLANS, payload: plans })
    },
  })

  return {
    updateProfileSelectedPlansLocally: refetch,
  }
}